
import React from 'react';
import { Container, Typography, Box, Divider, Card, CardContent } from '@mui/material';
import { ShieldCheck } from 'lucide-react';

const PrivacyPolicy = () => {
    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            {/* Page Header */}
            <Box sx={{ mb: 4, textAlign: 'center' }}>
                <Box sx={{
                    width: 56, height: 56, borderRadius: '14px',
                    backgroundColor: '#FEF2F2', border: '1px solid #FECACA',
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    mb: 2,
                }}>
                    <ShieldCheck size={28} color="#B11116" />
                </Box>
                <Typography variant="h4" component="h1" sx={{ fontWeight: 700, color: '#0F172A', letterSpacing: '-0.02em', mb: 1 }}>
                    Privacy Policy
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748B', maxWidth: 600, mx: 'auto' }}>
                    eRespiroConnect is committed to protecting the privacy and confidentiality of patient data and user information.
                </Typography>
            </Box>

            <Card sx={{ borderRadius: '14px', border: '1px solid #E2E8F0', boxShadow: '0 1px 3px rgba(0,0,0,0.04)', overflow: 'hidden' }}>
                <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                    <Typography variant="body1" paragraph sx={{ color: '#475569', lineHeight: 1.7, mb: 3 }}>
                        This Privacy Policy outlines how we collect, use, store, and safeguard the information within our digital health platform.
                    </Typography>

                    <Divider sx={{ my: 3, borderColor: '#F1F5F9' }} />

                    {[
                        {
                            title: "1. Information Collection",
                            text: "eRespiroConnect collects information necessary to provide comprehensive respiratory healthcare services, including patient registration details, diagnostic test results, treatment regimens, clinical follow-ups, and treatment outcomes."
                        },
                        {
                            title: "2. Use of Information",
                            text: "The collected information is used to facilitate diagnosis, treatment tracking, resistance profiling, and structured monitoring of patients with TB and other lung diseases. This data supports healthcare providers in improving treatment adherence, clinical decision-making, and patient outcomes."
                        },
                        {
                            title: "3. Data Storage and Security",
                            text: "All patient and user data is stored securely using industry-standard encryption and access control mechanisms. eRespiroConnect ensures that only authorized healthcare professionals and program managers can access sensitive information."
                        },
                        {
                            title: "4. Data Sharing",
                            text: "eRespiroConnect does not share personal patient information with unauthorized third parties. Data may be shared with healthcare tiers and program managers for the purpose of improving care coordination, monitoring, and reporting in compliance with public health guidelines."
                        },
                        {
                            title: "5. User Rights",
                            text: "Patients and users have the right to access, update, or request deletion of their personal data in accordance with applicable regulations. Requests should be directed to the healthcare provider or program administrator managing the patient account."
                        },
                        {
                            title: "6. Compliance",
                            text: "eRespiroConnect adheres to national and international standards for TB control, non-communicable disease management, and digital health data privacy. The platform is designed to maintain confidentiality, integrity, and security of sensitive medical information."
                        },
                        {
                            title: "7. Contact",
                            text: "For any questions regarding this Privacy Policy or to exercise your data rights, please contact your healthcare provider or program administrator using the official eRespiroConnect channels."
                        },
                    ].map((section, idx) => (
                        <Box key={idx} sx={{ mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, color: '#0F172A', fontSize: '1rem', mb: 1 }}>
                                {section.title}
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#475569', lineHeight: 1.7 }}>
                                {section.text}
                            </Typography>
                        </Box>
                    ))}

                    <Divider sx={{ my: 3, borderColor: '#F1F5F9' }} />

                    <Typography variant="body2" sx={{ color: '#94A3B8', textAlign: 'center', fontSize: '0.8125rem' }}>
                        &copy; {new Date().getFullYear()} eRespiroConnect — Dopasi Foundation. All rights reserved.
                    </Typography>
                </CardContent>
            </Card>
        </Container>
    );
};

export default PrivacyPolicy;
